<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="data"
          :model="data"
          :rules="rules"
          label-width="120px"
          style="width: 90%"
        >
          <el-form-item label="寻呼台" prop="DeviceId">
            <el-radio-group v-model="data.DeviceId"
              ><el-radio
                :label="item.DeviceId"
                :key="item.DeviceId"
                v-for="item in MICArray"
              >{{item.DeviceName}}</el-radio
            ></el-radio-group>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button type="primary" @click="OnConfirm('data')">确认</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "MICInfo",
  props: {
    MICArray: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      data: {
        DeviceId: null,
      },
      rules: {
        DeviceId: [
          { required: true, message: "请选择寻呼台", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    MICArray: {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        (this.data = {
          DeviceName: "",
        });
          //this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    OnConfirm(formName) {
      //  const that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
         this.$emit("clickConfirm", this.data.DeviceId);
        } else {
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
  },
};
</script>

<style></style>
